import { route } from "../../../../application/domain/routing/named-route";
import { ServiceProviderSmartApplyProceduresBulkExportByCSV } from "./procedures/bulk-export-by-csv";
import { ServiceProviderSmartApplyProceduresBulkImportByCSV } from "./procedures/bulk-import-by-csv";

export const ServiceProviderSmartApplyRoutes = {
  SmartApplyProceduresBulkExportByCSV: route({
    path: "/service-provider/orgs/:id/smart-apply/procedures-bulk-export-by-csv",
    link: (args: { id: string }) =>
      `/service-provider/orgs/${args.id}/smart-apply/procedures-bulk-export-by-csv`,
    component: ServiceProviderSmartApplyProceduresBulkExportByCSV,
  }),
  SmartApplyProceduresBulkImportByCSV: route({
    path: "/service-provider/orgs/:id/smart-apply/procedures/bulk-import-by-csv",
    link: (args: { id: string }) =>
      `/service-provider/orgs/${args.id}/smart-apply/procedures/bulk-import-by-csv`,
    component: ServiceProviderSmartApplyProceduresBulkImportByCSV,
  }),
};
